import { defineComponent as _defineComponent } from 'vue'
import { useTaishokutodokeFormatData } from '@/composables/format-edit/useTaishokutodokeFormatData'
import documentTitleOptions from '@/utils/format-edit/taishokutodokeDocumentTitleOptions.json'


export default /*#__PURE__*/_defineComponent({
  __name: 'TaishokutodokeCompanyCard',
  props: {
    currentCardId: null
  },
  setup(__props: any) {



const formatData = useTaishokutodokeFormatData()

return { __sfc: true,formatData, documentTitleOptions }
}

})